/* eslint-disable react/prop-types */
import Router from 'next/router'
import {getDocumentById} from 'utils/db.utils'
import UserChatRoom from 'modules/chat/pages/ChatRoom'
import {useEffect} from 'react'

export async function getServerSideProps(context) {
  const {params, res, query} = context
  const {room} = params
  const {success} = query

  const chatRoom = await getDocumentById('chats', room)

  if (!chatRoom) {
    const errorCode = 404
    res.statusCode = errorCode
    return {props: {errorCode, errorTitle: 'Page Not Found'}}
  }

  const {description} = chatRoom
  const pageTitle = description
    ? `${description} | Encrypted Chat`
    : 'Encrypted Chat'

  return {props: {chatRoom, pageTitle, isSuccess: !!success}}
}

const ChatRoom = ({chatRoom, isSuccess}) => {
  useEffect(() => {
    if (isSuccess) {
      const newPath = Router.asPath.split('?', 1)[0]
      // Using history API instead of Router here, because somehow
      // the following does not work when fetching more data:
      // Router.replace(newPath, {shallow: false})
      if (window.history) {
        window.history.replaceState({}, document.title, newPath)
      }
    }
  }, [isSuccess])

  return <UserChatRoom room={chatRoom} showDetailsOnLoad={isSuccess} />
}

export default ChatRoom
